var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information texture-bg-css"},[_c('Top'),_c('Storage'),_c('Storehouse')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }